import ActionTypes             from '../../ActionTypes';
import {
    getNextConversation,
    getSmartListStatus
}                              from '../../services/NextConversationService';

import { UserSession }         from '../../types';
import { getSession }          from '../../services/SessionService';
import { MessagesError }       from '../../reduxTypes';

export const nextConvoLoading = () => ({
    type: ActionTypes.NEXT_CONVO_LOADING
});

export const nextConvoIdLoaded = (conversationId: number, callListId: number, activityType?: string) => ({
    type: ActionTypes.NEXT_CONVO_ID_LOADED,
    conversationId,
    callListId,
    activityType
});

export const nextConvoLoadError = (error: MessagesError) => ({
    type: ActionTypes.NEXT_CONVO_LOADING_ERROR,
    error
});

export const nextConvoLoaded = () => ({
    type: ActionTypes.NEXT_CONVO_LOADED
});

export const smartListStatusLoaded = (hasSmartList: boolean) => ({
    type: ActionTypes.SMART_LIST_STATUS_LOADED,
    hasSmartList
});

export const smartListStatusError = (error: MessagesError) => ({
    type: ActionTypes.SMART_LIST_STATUS_ERROR,
    error
});

export function loadNextConversationId() {
    return async function loadNextConversationIdAction(dispatch) {
        dispatch(nextConvoLoading());

        try {
            const session: UserSession = await getSession();
            const { conversation_id: conversationId, list_id: callListId, activity_type: activityType } = await getNextConversation(session);

            dispatch(nextConvoIdLoaded(conversationId, callListId, activityType));
        } catch (error) {
            dispatch(nextConvoLoadError(error));
        }
    };
}

export function loadSmartListStatus() {
    return async function loadSmartListStatusAction(dispatch) {
        try {
            const session: UserSession = await getSession();
            const hasSmartList = await getSmartListStatus(session);

            dispatch(smartListStatusLoaded(hasSmartList));
        } catch (error) {
            dispatch(smartListStatusError(error));
        }
    };
}



// WEBPACK FOOTER //
// ./src/sections/NextConversation/NextConversationActions.ts